import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    current: null,
    gallery: []
  },
  mutations: {
    setCurrent (state, current) {
      state.current = current
    },
    setGallery (state, gallery) {
      state.gallery = gallery
    }
  },
  actions: {
    setCurrent ({ commit }, current) {
      commit('setCurrent', current)
    },
    setGallery ({ commit }, gallery) {
      commit('setGallery', gallery)
    }
  },
  getters: {
    gallery (state) {
      return state.gallery
    },
    next (state) {
      if (state.gallery.length && state.current) {
        const index = state.gallery.indexOf(state.current)

        if (index > -1 && index < state.gallery.length - 1) {
          return state.gallery[index + 1]
        }
      }

      return null
    },
    previous (state) {
      if (state.gallery.length && state.current) {
        const index = state.gallery.indexOf(state.current)

        if (index > -1 && index > 0) {
          return state.gallery[index - 1]
        }
      }

      return null
    }
  }
})
